import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { List, Drawer, IconButton, Box, ListItemText, ListItemIcon } from '@mui/material';
// config
import { NAV } from '../../../../config-global';
// components
import Logo from '../../../../components/minimal/logo';
import Iconify from '../../../../components/minimal/iconify';
import Scrollbar from '../../../../components/minimal/scrollbar';
//
import NavList from './NavList';
import { ListItem } from './styles';
import { getMarketplaceLogo } from "../../../../utils/market";
import { fontWeight, Stack } from '@mui/system';

// ----------------------------------------------------------------------

NavMobile.propTypes = {
  data: PropTypes.array,
  isOffset: PropTypes.bool,
};

export default function NavMobile({ isOffset, data, logoComponent, hasActiveSubscriptions, onShowEntryCode, translate }) {
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEntryCodeClick = () => {
    handleClose();
    onShowEntryCode();
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          color: 'black',
        }}
      >
        <Iconify width={'2rem'} icon="material-symbols:menu" />
      </IconButton>

      <Drawer
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            pb: 5,
            width: NAV.W_BASE,
          },
        }}
      >
        <Scrollbar>
          <Stack sx={{ m: 1, alignItems: 'center' }}>
            {logoComponent}
          </Stack>

          <List component="nav" disablePadding>

            {data.map((link) => (
              <NavList key={link.title} item={link} sx={{ fontWeight: 'bold' }} />
            ))}

            {hasActiveSubscriptions && (
              <ListItem onClick={handleEntryCodeClick} sx={{ fontWeight: 'bold' }}>
                <ListItemIcon>
                  <Iconify icon="eva:qr-code-outline" />
                </ListItemIcon>
                <ListItemText disableTypography primary={translate('entry_code')} />
              </ListItem>
            )}
          </List>
        </Scrollbar>
      </Drawer>
    </>
  );
}
